'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var GlobalConst = require('../../types/GlobalConst');
var util = require('../../helper/util');
var appTypes = require('../../types/appTypes');

/*
 @Author : mengxiaojiang
 @CreateDate : 2016-3-29
 @Descript : 下拉列表框组件
 */
var ComboBoxBase = React.createClass({
  render: function () {
    var selectedValue = this.props.items[this.props.selectedIndex] || 0;
    return (<div
      key="select"
      style={{
        width: '100%',
        height: '100%',
        fontWeight: this.props.fontWeight,
        color: this.props.color,
        fontSize: this.props.fontSize,
        fontFamily: this.props.fontFamily,
        fontStyle: this.props.fontStyle,
        textDecoration: this.props.textDecoration
      }}>
      <select
        ref="select"
        style={{
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          borderColor: this.props.borderColor,
          borderRadius: 0,
          textDecoration: 'inherit',
          fontWeight: 'inherit',
          color: 'inherit',
          fontSize: 'inherit',
          fontFamily: 'inherit',
          fontStyle: 'inherit',
          position: 'relative',
          outline: 'none',
          opacity: 0
        }}
        defaultValue={selectedValue}
        onChange={this._onSelect}>
        {
          this.props.items.map(function (itemStr, index) {
            return (
              <option key={index}
                      value={itemStr}>
                {itemStr}
              </option>);
          }, this)
        }
      </select>
      <div ref="combobox"
           style={{
             width: '100%',
             height: '100%',
             left: 0,
             top: 0,
             position: 'absolute',
             border: 'none',
             pointerEvents: 'none',
             zIndex: 10,
             textDecoration: 'inherit'
           }}>
        <canvas style={{width: '100%', height: '100%'}} ref="ctx"/>
        <div ref="txt" style={{
          position: 'absolute',
          height: '100%',
          top: 0,
          left: 5,
          right: 21,
          bottom: 0,
          textDecoration: 'inherit',
          fontWeight: this.props.fontWeight,
          color: this.props.color,
          fontSize: this.props.fontSize,
          fontFamily: this.props.fontFamily,
          fontStyle: this.props.fontStyle,
          whiteSpace: 'nowrap',
          overflow: 'hidden'
        }}>
          <label>{this.state.value}</label>
        </div>
      </div>
      {
        this.props.canInput &&
        <input ref="input" style={{
          right: 20,
          bottom: 1,
          left: 1,
          top: 1,
          position: 'absolute',
          zIndex: 20,
          borderStyle: 'none',
          borderColor: GlobalConst.GLOBAL_COLOR.TRANSPARENT_COLOR,
          backgroundColor: this.props.backgroundColor,
          textDecoration: 'inherit',
          fontWeight: 'inherit',
          color: 'inherit',
          fontSize: 'inherit',
          fontFamily: 'inherit',
          fontStyle: 'inherit',
          outline: 'none',
          textIndent: 5
        }} onInput={this._onInput}/>
      }
    </div>);
  },

  componentDidMount: function () {
    this.doSelect();
    this.doPaint();
    $(ReactDOM.findDOMNode(this.refs.combobox)).css({lineHeight: ReactDOM.findDOMNode(this).getBoundingClientRect().height + 'px'});
    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_PAINT, this.onPaint);
  },

  componentDidUpdate: function () {
    this.doPaint();
  },

  doPaint: function () {
    var canvas = ReactDOM.findDOMNode(this.refs.ctx);

    var g = canvas.getContext('2d');
    var w = canvas.clientWidth;
    var h = canvas.clientHeight;
    var iconH = 4;
    var iconW = 8;
    var btnW = 16;
    var thickness = 1;
    var t;
    canvas.width = w;
    canvas.height = h;

    g.clearRect(0, 0, w, h);
    g.fillStyle = '#fff';
    g.strokeStyle = this.props.borderColor || '#444';
    g.lineWidth = 1;
    g.beginPath();
    g.rect(thickness / 2, thickness / 2, w - thickness, h - thickness);
    g.closePath();
    g.fill();
    g.stroke();
    if (this.props.backgroundColor && this.props.backgroundColor !== '#fff' && this.props.backgroundColor !== 'rgba(255,255,255,1)') {
      g.fillStyle = this.props.backgroundColor;
      g.beginPath();
      g.rect(thickness, thickness, w - btnW - thickness * 2, h - thickness * 2);
      g.closePath();
      g.fill();
    }
    g.beginPath();
    g.moveTo(w - btnW - thickness / 2, 0);
    g.lineTo(w - btnW - thickness / 2, h);
    g.closePath();
    g.stroke();

    g.beginPath();
    g.fillStyle = '#444';// g.strokeStyle;

    t = Math.round((h - iconH) / 2);
    g.moveTo(w - btnW + (btnW - iconW) / 2 - thickness / 2, t);
    g.lineTo(w - (btnW - iconW) / 2 - thickness / 2, t);
    g.lineTo(w - btnW / 2 - thickness / 2, t + iconH);
    g.closePath();
    g.fill();

    $(ReactDOM.findDOMNode(this.refs.txt)).css({lineHeight: h + 'px'})
  },

  getInitialState: function () {
    return {
      value: this.props.items[this.props.selectedIndex]
    };
  },

  onPaint: function () {
    this.doPaint();
  },

  doSelect: function () {
    var input;
    var select = ReactDOM.findDOMNode(this.refs.select);
    var value = select.options[select.selectedIndex].text;
    if (this.props.canInput) {
      input = ReactDOM.findDOMNode(this.refs.input);
      input.value = value;
    }

    this.setState({value: value});
  },

  _onSelect: function (e) {
    this.doSelect();
    var select = ReactDOM.findDOMNode(this.refs.select);
    if (this.props.onItemClick) {
      this.props.onItemClick(e, select.selectedIndex);
    }
  },

  _onInput: function () {
    var input = ReactDOM.findDOMNode(this.refs.input);
    var select = ReactDOM.findDOMNode(this.refs.select);
    select.options[select.selectedIndex].text = input.value;
  }
});

module.exports = ComboBoxBase;



// WEBPACK FOOTER //
// ./src/views/common/ComboBoxBase.jsx